const showBox = document.querySelectorAll('.show-box');

showBox.forEach(block => {
  const showBtn = block.querySelector('.show-btn');

  if (!showBtn) return;

  showBtn.addEventListener('click', e => {
    block.classList.toggle('is-open');
    showBtn.classList.toggle('is-open');

    setTimeout(() => {
      block.classList.toggle('is-visible');
    }, 100);
  });
});

